module.exports = __webpack_public_path__ + "img/usina-bg2.56e9bfe7.jpg";